import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, provideAppInitializer, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideNgxStripe } from 'ngx-stripe';

import { PLUTO_ID } from './app/services/payment.service';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import MyPreset from './mypreset';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './app/interceptors/error.interceptor';
import { AppInitService } from './app/services/app-init.service';
import { initializeApp } from './app/factories/app-init.factory';
import { environment } from '@environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ClarityService } from './app/services/clarity.service';
import { APP_SHELL_IS_MOBILE } from './app/tokens/app-shell.token';
import { TabService } from './app/core/services/tab.service';

export const appConfig: ApplicationConfig ={
    providers: [
      importProvidersFrom(
        BrowserModule,
        AppRoutingModule,
        ToastModule
      ),
      MessageService,
      { provide: APP_SHELL_IS_MOBILE, useValue: false },
      ConfirmationService,
      provideNgxStripe(environment.stripeSecret),
      {
        provide: PLUTO_ID,
        useValue: '449f8516-791a-49ab-a09d-50f79a0678b6',
      },
      provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: MyPreset,
          
          options: { darkModeSelector: '.app-dark', cssLayer: false},
          
        },
        ripple: true,
        
      }),
      DialogService,
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      provideHttpClient(withInterceptorsFromDi()),
      // Initialize branding and theming before app starts
      {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [AppInitService],
        multi: true
      },
      // Initialize Clarity analytics (loads correct script based on environment)
      provideAppInitializer(() => {
        const clarityService = inject(ClarityService);
        clarityService.loadClarity();
        return Promise.resolve();
      }),
      // Resolve initial tab ownership before initial routing/module loading.
      provideAppInitializer(() => {
        const tabService = inject(TabService);
        return tabService.awaitInitialCheck();
      }),
      // provideServiceWorker('ngsw-worker.js', { enabled: environment.production })
    ],
  };
